{
  "Approve": "核准",
  "DeleteReminder": "刪除提醒",
  "DismissAlert": "關閉",
  "DismissReminder": "關閉提醒",
  "Earlier": "較早",
  "EditReminder": "編輯提醒",
  "High": "高",
  "MarkAllAsRead": "全部標記為已讀",
  "Reject": "拒絕",
  "RemindMe15Min": "15 分鐘後再提醒我",
  "RemindMe5Min": "5 分鐘後再提醒我",
  "RemindMe60Min": "1 小時後再提醒我",
  "RemindMeTomorrow": "明天再提醒我",
  "Snooze": "提醒我",
  "markAsRead": "標記為已讀",
  "markAsUnread": "標記為未讀",
  "noNotifications": "您會收到產品、您和其他使用者的協作情況，以及其他相關更新的重要資訊",
  "noNotificationsTitle": "通知會顯示於此處"
}
